import { FC } from "react";
import { Agency } from "@/types";

import AppTable from "@/components/AppTable";
import AppTableContainer from "@/components/AppTableContainer";
import AppTableHead from "@/components/AppTable/AppTableHead";
import AppTableBody from "@/components/AppTable/AppTableBody";
import AppTableRow from "@/components/AppTable/AppTableRow";
import AppTableCell from "@/components/AppTable/AppTableCell";
import AppTableHeaderCell from "@/components/AppTable/AppTableHeaderCell";
import AppText from "@/components/AppText";
import AppIcon from "@/components/AppIcon";
import AppTooltip from "@/components/AppTooltip";

interface AgenciesTableProps {
  tableRows: Agency[];
  onAddUser: (agency: Agency) => void;
}

const AgenciesTable: FC<AgenciesTableProps> = ({ tableRows, onAddUser }) => {
  return (
    <AppTableContainer>
      <AppTable>
        {/* Table Head */}
        <AppTableHead>
          <AppTableRow>
            <AppTableHeaderCell>Agency Name</AppTableHeaderCell>
            <AppTableHeaderCell>Agency Admin</AppTableHeaderCell>
            <AppTableHeaderCell align="center">Actions</AppTableHeaderCell>
          </AppTableRow>
        </AppTableHead>

        {/* Table Body */}
        <AppTableBody>
          {tableRows.length ? (
            tableRows.map((row, index) => (
              <AppTableRow
                key={index}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                {/* Name */}
                <AppTableCell className="py-4">
                  <AppText>{row.name}</AppText>
                </AppTableCell>

                {/* Agency Admin */}
                <AppTableCell>
                  <AppText>
                    {row.admin
                      ? `${row.admin.name} (${row.admin.email})`
                      : "N/A"}
                  </AppText>
                </AppTableCell>

                {/* Delete Action */}
                {/* <AppTableCell align="center">
                  <DeleteIcon
                    className="text-red-500 cursor-pointer hover:text-red-700"
                    onClick={() => onDelete(row)}
                  />
                </AppTableCell> */}

                {/* Add User Action */}
                <AppTableCell align="center">
                  <AppTooltip title="Add User">
                    <AppIcon
                      name="addUser"
                      className="text-primary cursor-pointer hover:text-primary-hover"
                      onClick={() => onAddUser(row)}
                    />
                  </AppTooltip>
                </AppTableCell>
              </AppTableRow>
            ))
          ) : (
            <AppTableRow>
              <AppTableCell
                colSpan={4}
                className="text-center text-gray-500 py-3"
              >
                No results
              </AppTableCell>
            </AppTableRow>
          )}
        </AppTableBody>
      </AppTable>
    </AppTableContainer>
  );
};

export default AgenciesTable;